// extracted by mini-css-extract-plugin
module.exports = {"headings":"styles_headings__1lKHG","headings-wrapper":"styles_headings-wrapper__23z2n"};